<div>
  <span class="material-icons-round text-danger">report_problem</span>
  <h1 *ngIf="statusCode" class="text-danger">{{ statusCode }}</h1>
  <p *ngIf="message" class="text-muted">{{ message }}</p>
</div>
